"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = `
mutation changeCoachingDays($subscriptionId: Int!, $coachingDays: [DayOfWeekType]!) {
  changeCoachingDays(subscriptionId: $subscriptionId, coachingDays: $coachingDays) {
    success
    messages
  }
}
`;
//# sourceMappingURL=changeCoachingDayMutation.js.map